import { RegionDTO } from '../../types/parameters.types';
import { RegionThumbnailCard } from '../Cards/RegionThumbnailCard/RegionThumbnailCard';
import { SearchBar } from '@practium/ui';
import styles from './SelectBaseLeftPanel.module.css';

interface SelectBaseLeftPanelProps {
	regions: RegionDTO[];
	searchQuery: string;
	previewedRegionId: string | null;
	onSearchChange: (q: string) => void;
	onPreviewRegion: (region: RegionDTO) => void;
}

export const SelectBaseLeftPanel = ({
	regions,
	searchQuery,
	previewedRegionId,
	onSearchChange,
	onPreviewRegion,
}: SelectBaseLeftPanelProps) => {
	const filtered = regions.filter((r) => r.name.toLowerCase().includes(searchQuery.toLowerCase()));

	return (
		<div className={styles.panel}>
			<SearchBar value={searchQuery} onChange={onSearchChange} />

			<div className={styles.grid}>
				{filtered.map((region) => (
					<RegionThumbnailCard
						key={region._id}
						id={region._id}
						name={region.name.replace('Região ', '')}
						stateCodes={region.stateCodes}
						isSelected={previewedRegionId === region._id}
						onClick={() => onPreviewRegion(region)}
					/>
				))}
			</div>
		</div>
	);
};
